<template>
  <div>
    <div class="head">
      <div class="headbox1">
        <div class="headtitle">淼佳网络</div>
      </div>
      <div class="headbox2"></div>
      <div class="headbox3">
        <div class="headbox3box">
          <div
            class="headbtn"
            :class="this.isshow == 1 ? 'headbtn1' : ''"
            @click="jumpClick1()"
          >
            首页
          </div>
          <div
            class="headbtn"
            :class="this.isshow == 2 ? 'headbtn1' : ''"
            @click="jumpClick2()"
          >
            关于我们
          </div>
          <div
            class="headbtn"
            :class="this.isshow == 3 ? 'headbtn1' : ''"
            @click="jumpClick3()"
          >
            公司产品
          </div>
        </div>
      </div>
    </div>
    <div
      :class="this.isshow == 3 || this.isshow == 2 ? 'headone' : 'headtwo'"
    ></div>
    <div class="contentbox1" id="box1">
      <div class="content1title">
        <div class="content1title1">广西淼佳网络科技有限公司</div>
        <div class="content1title2">XinMiao Technology Co. Ltd.</div>
      </div>
    </div>
    <div class="contentbox2" id="box2">
      <div class="img1"></div>
      <div class="contentbox2box1">
        <div class="contentbox2title1">公司简介</div>
        <div class="contentbox2title2">
          淼佳科技成立于2022年，是一家专注于C端APP自研开发的高新技术企业。我们致力于为客户提供创新的软件产品和高品质的服务，满足用户日益增长的移动互联网需求。作为一家创新型的企业，我们不断推陈出新，不断开拓市场和技术边界，让用户享受到更好的使用体验。
        </div>
      </div>
      <div class="img2"></div>
    </div>
    <div class="contentbox3" id="box3">
      <div class="contentbox3box1">
        <div class="box1">
          <div class="box1img"></div>
          <div class="box1title">
            <div class="box1title1">蜜柚剧场</div>
            <div class="box1titleimmg"></div>
            <div class="box1title2">38万下载 42.09M</div>
          </div>
        </div>
        <div class="box2">
          该软件是一款超好用的影视软件~更方便、更快捷、内容更丰富、操作更简易！众多短剧供你观赏！快来体验吧！！
        </div>
        <div class="box3">桂ICP备2022009009号-3A</div>
      </div>
      <div class="contentright">
        <div class="contentrightimg1"></div>
        <div class="contentrightimg2"></div>
        <div class="contentrightimg3"></div>
        <div class="contentrightimg4"></div>
      </div>
    </div>
    <div class="contentbox3" id="box3">
      <div class="contentbox3box1">
        <div class="box1">
          <div class="box1imgs"></div>
          <div class="box1title">
            <div class="box1title1">番茄小短剧</div>
            <div class="box1titleimmg"></div>
            <div class="box1title2">38万下载 42.09M</div>
          </div>
        </div>
        <div class="box2">
          樱桃剧场是一款超好用的短剧APP~超多内容供您选择！！内容丰富操作简单！快来体验吧！！
        </div>
        <div class="box3s">桂ICP备2022009009号-8A</div>
      </div>
      <div class="contentright">
        <div class="contentrightimg1s"></div>
        <div class="contentrightimg2s"></div>
        <div class="contentrightimg3s"></div>
        <div class="contentrightimg4s"></div>
      </div>
    </div>
    <div class="bottombox">
      <div>
        公司地址：中国（广西）自由贸易试验区南宁片区平乐大道15号五象绿地中心2号楼14层1409号房A26号
      </div>
      <a target="_blank" href="https://beian.miit.gov.cn/">
        <div>
          主体备案号：<span style="color: #54b5e1">桂ICP备2022009009号</span>
        </div>
      </a>
      <a target="_blank" href="https://beian.miit.gov.cn/">
        <div>
          服务备案号： <span style="color: #54b5e1">桂ICP备2022009009号-2</span>
        </div>
      </a>
      <a target="_blank" href="http://miaojia6.cn/mj.pdf">
        <div>
          桂网文： <span style="color: #54b5e1">桂网文（2023）0950-264号</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      isshow: 1,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getScroll() {
      return {
        left:
          window.pageXOffset ||
          document.documentElement.scrollLeft ||
          document.body.scrollLeft ||
          0,
        top:
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0,
      };
    },
    handleScroll() {
      const scrollTop = this.getScroll().top;
      //获取盒子高度
      if (scrollTop >= 1080 && scrollTop <= 2160) {
        this.isshow = 2;
      } else if (scrollTop >= 2160) {
        this.isshow = 3;
      } else {
        this.isshow = 1;
      }
    },
    jumpClick1() {
      this.isshow = 1;
      document.querySelector("#box1").scrollIntoView(true);
    },
    jumpClick2() {
      this.isshow = 2;
      document.querySelector("#box2").scrollIntoView(true);
    },
    jumpClick3() {
      this.isshow = 3;
      document.querySelector("#box3").scrollIntoView(true);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  display: flex;
  z-index: 1;
}
.headone {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  display: flex;
  background-color: #232323;
}
.headtwo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  display: flex;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
}
.headbox1 {
  width: 288px;
  height: 120px;
}
.headtitle {
  margin-top: 37px;
  margin-left: 160px;
  width: 128px;
  height: 45px;
  font-family: "Alimama ShuHeiTi";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 45px;
  text-transform: uppercase;
  color: #ffffff;
  text-shadow: 0px 3px 6px rgba(19, 72, 128, 0.2);
  flex: none;
  order: 0;
  flex-grow: 0;
}
.headbox2 {
  flex: 1;
}
.headbox3 {
  width: 600px;
  height: 120px;
}
.headbox3box {
  display: flex;
  width: 440px;
  height: 120px;
}
.headbtn {
  z-index: 2;
  margin-top: 34px;
  text-align: center;
  width: 120px;
  height: 51px;
  border-radius: 49px;
  margin-left: 40px;
  background-color: #ffffff;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 51px;
  align-items: center;
  text-transform: uppercase;
  color: #0d356d;
}
.headbtn1 {
  background: rgba(13, 53, 109, 0.3);
  color: #ffffff;
}
.contentbox1 {
  width: 100%;
  height: 1080px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/BG.png");
  background-size: 100% 1080px;
}
.content1title1 {
  text-align: center;
  width: 100%;
  height: 96px;
  padding-top: 427px;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 700;
  font-size: 70px;
  line-height: 96px;
  color: #ffffff;
}
.content1title2 {
  text-align: center;
  width: 100%;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 41px;
  color: rgba(255, 255, 255, 0.5);
}
.contentbox2 {
  width: 100%;
  height: 1080px;
  background-color: #ffffff;
  display: flex;
}
.contentbox2box1 {
  margin-top: 329px;
}
.img1 {
  margin-left: 8%;
  width: 1%;
  height: 1080px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/插图-时间线.png");
  background-size: 100% 1080px;
}
.contentbox2box1 {
  width: 38%;
}
.contentbox2title1 {
  width: 100%;
  margin-top: 2%;
  margin-left: 3%;
  font-family: "Alimama ShuHeiTi";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 67px;
  color: #1a385a;
}
.contentbox2title2 {
  width: 100%;
  margin-left: 4%;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 150%;
  color: #1a385a;
}
.img2 {
  margin-top: 175px;
  margin-left: 4%;
  width: 45%;
  height: 732px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/插图-公司简介.png");
  background-size: 100% 732px;
}
.contentbox3 {
  width: 100%;
  height: 1080px;
  background-color: #484848;
  display: flex;
  overflow: hidden;
}
.contentbox3box1 {
  padding-top: 276px;
  margin-left: 9%;
  width: 519px;
  height: 528px;
}
.box1 {
  display: flex;
}
.box1img {
  width: 176px;
  height: 176px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/appicon.png");
  background-size: 176px 176px;
}
.box1imgs {
  width: 176px;
  height: 176px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/icon2.png");
  background-size: 176px 176px;
}
.box1title {
  margin-left: 8%;
}
.box1title1 {
  font-family: "Alimama ShuHeiTi";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 67px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #ffffff;
}
.box1titleimmg {
  margin-top: 12px;
  width: 100%;
  height: 42px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/星星.png");
  background-size: 100% 100%;
}
.box1title2 {
  margin-top: 12px;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 150%;
  text-transform: uppercase;
  color: #ffffff;
  opacity: 0.5;
}
.box2 {
  margin-top: 40px;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 150%;
  text-transform: uppercase;
  color: #ffffff;
}
.box3 {
  margin-top: 60px;
  width: 470px;
  height: 72px;
  background: #55b5e1;
  border-radius: 12px;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 72px;
  text-align: center;
  color: #ffffff;
}
.box3s {
  margin-top: 60px;
  width: 470px;
  height: 72px;
  background: #55b5e1;
  border-radius: 12px;
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 72px;
  text-align: center;
  color: #ffffff;
}
.contentright {
  margin-top: 240px;
  display: flex;
  margin-left: 6%;
  margin-right: -20%;
}
.contentrightimg1 {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/计步达人-市场图-001.png");
  background-size: 100% 100%;
}
.contentrightimg2 {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/计步达人-市场图-002.png");
  background-size: 100% 100%;
}
.contentrightimg3 {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/计步达人-市场图-003.png");
  background-size: 100% 100%;
}
.contentrightimg4 {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/计步达人-市场图-004.png");
  background-size: 100% 100%;
}
.contentrightimg1s {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/fqxdj1.jpg");
  background-size: 100% 100%;
}
.contentrightimg2s {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/fqxdj2.png");
  background-size: 100% 100%;
}
.contentrightimg3s {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/fqxdj3.png");
  background-size: 100% 100%;
}
.contentrightimg4s {
  width: 337px;
  height: 600px;
  background-image: url("http://prodcdn.toponegames.cn/png/miaojia/fqxdj4.png");
  background-size: 100% 100%;
}
.bottombox {
  width: 100%;
  height: 165px;
  background: #232323;
  padding-top: 75px;
}
.bottombox div {
  font-family: "Alibaba PuHuiTi";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  /* or 30px */
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue